import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderService, ToastService } from 'src/app/shared/services';
import { Constants } from 'src/app/shared/constant/constants';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AUTH } from '@app/shared/constant/routes';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FocusOnInitDirective } from '@app/shared/directive/modal-focus.directive';

@Component({
  selector: 'app-access-code-modal',
  styleUrls: ['./access-code-modal.component.scss'],
  templateUrl: './access-code-modal.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, NgIf, TranslateModule, FocusOnInitDirective],
})
export class AccessCodeModalComponent {
  private baseUrl: string;
  @Input() accessToken!: string;

  accessCodeForm = this.fb.group({
    isShowAccessCode: false,
    licenseCode: '',
  });

  constructor(
    private fb: FormBuilder,
    private loader: LoaderService,
    private flashMessage: ToastService,
    private readonly modalService: BsModalService,
    private readonly http: HttpClient,
    private router: Router,
    private translateService: TranslateService,
  ) {
    this.baseUrl = environment.baseApiURL;
    this.onChanges();
  }

  onChanges(): void {
    this.accessCodeForm.get('isShowAccessCode')?.valueChanges.subscribe(isShowAccessCode => {
      const licenseCodeControl = this.accessCodeForm.get('licenseCode');
      if (isShowAccessCode) {
        licenseCodeControl?.setValidators([Validators.required, Validators.maxLength(10)]);
      } else {
        licenseCodeControl?.clearValidators();
        licenseCodeControl?.markAsUntouched();
        licenseCodeControl?.setValue('');
      }
      licenseCodeControl?.updateValueAndValidity();
    });
  }

  toggleLicenseCodeField() {
    const currentValue = this.accessCodeForm.get('isShowAccessCode')?.value;
    this.accessCodeForm.patchValue({
      isShowAccessCode: !currentValue, // Toggle the value
    });
  }

  useCode() {
    // * If form is invalid then return early
    if (this.accessCodeForm.invalid) return;

    // * If user does not enter the licenseCode then simply navigate
    if (!this.accessCodeForm.value.licenseCode || !this.accessCodeForm.value.isShowAccessCode) {
      this.modalService.hide();
      this.translateService.get('SUCCESS.registeredUser').subscribe((translatedMessage: string) => {
        this.flashMessage.showSuccess(translatedMessage);
      });
      this.router.navigate([AUTH.URL]);
      return;
    }

    // * Below case run when user enter the licenseCode
    this.accessCodeForm.markAllAsTouched();
    if (!this.accessCodeForm.invalid) {
      this.loader.start();

      //HTTP POST Request:
      this.http
        .post(
          `${this.baseUrl}${Constants.ENDPOINTS.applyLicenseCode}`,
          {
            licenseCode: this.accessCodeForm.value.licenseCode,
          },
          {
            headers: {
              token: this.accessToken,
              'X-Skip-Interceptor': 'true',
            },
          },
        )
        .subscribe(
          (res: any) => {
            this.loader.stop();
            this.modalService.hide();
            const message = res.message + ' and registration completed';
            this.flashMessage.showSuccess(message);
            this.router.navigate([AUTH.URL]);
          },
          error => {
            this.loader.stop();
            this.flashMessage.showError(error.error.errorMessage);
          },
        );
    }
  }

  onSubmit() {
    this.useCode();
  }
}
